/**
 * CSV modifications
 **/

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');

    module.exports = {
        /**
         * [jsonToCsv get arrays with data as arguments]
         * @return {[String]} [GeneratedContent]
         */
        jsonToCsv: function() {
            var startLine = 'data:text/csv;charset=UTF-8,';
            var newLine = '\n';
            var args = Array.prototype.slice.call(arguments, []);

            args.reverse();
            args = _.compact(args);

            var content = args.reduce(function(newContent, arg) {
                var titles = _.keys(arg[0]).join();
                var body = arg.reduce(function(result, data) {
                    result += _.values(data).map(function(val) {
                        return '"' + val + '"';
                    });

                    return result + newLine;
                }, '');

                newContent += '\uFEFF';
                newContent += newContent.length > 1 ? newLine : '';

                return newContent + [titles, body].join(newLine);
            }, '');

            content = content.replace(`${newLine}""${newLine}`, newLine);

            return startLine + encodeURIComponent(content);
        },

        csvToJson: function(csv) {
            var newLine = '\n';
            var lines = csv.split(newLine);

            // remove last empty line
            if (lines[lines.length - 1] === '') {
                lines.splice(-1);
            }

            var headers = lines[0].split(',');
            var result = [];

            for(var i = 1; i < lines.length; i++) {
                var obj = {};
                var currentline = lines[i].split(',');

                for(var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }

                result.push(obj);
            }
            // remove caret return symbol
            return JSON.stringify(result).replace(/\\r/g, ''); //JSON
        },

        /**
         * Convert to CSV format where keys in object are csv header
         * @param  {Object}  args.data                  array with objects
         * @param  {String}  [args.columnDelimiter]     delimiter between columns (coma by default)
         * @param  {String}  [args.lineDelimiter]       delimiter between line (new line by default)
         * @returns {String}
         */
        convertArrayOfObjectsToCSV: function(args) {
            var data = args.data || null;

            if (data === null || !data.length) {
                return null;
            }

            var columnDelimiter = args.columnDelimiter || ',';
            var lineDelimiter = args.lineDelimiter || '\n';
            var keys = Object.keys(data[0]);
            var result = '';

            result += keys.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function(item) {
                var ctr = 0;

                keys.forEach(function(key) {
                    if (ctr > 0) {
                        result += columnDelimiter;
                    }

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }
    };
});
